export default "__VITE_ASSET__CXlU0TKn__"